import useWindowDimensions, { decodeJWT } from "common/functions";
import React, { useEffect, useState } from "react"; 
import Connectors from "../ConnectorsPieChart/Connectors";
import i18n from "internationalization/i18n";
import Details from "../DetailsCharts/Details";
import InfoCard from "pages/dashboard/components/InfoCard/InfoCard";
import {SummaryResponse } from "services/utils/interfaces";
import {ReactComponent as MinusButton} from "assets/minus-button.svg";
import { uniqueId } from "lodash";
import { Button } from "antd";
import { dashboardApi, useSaveStatsMutation,useGetStationQuery } from "services/dashboardService";
import { useDispatch, useSelector } from "react-redux";
import { rootReducerType } from "redux/combineReducers";
import "./ContainerCharts.less";
import { emailToUsername } from "common/utils";
import Notification from "../NotificationMessage/Notification";
import Information from "components/Information/Information";
import Map from "pages/stations/components/Map/Map";
import StationMap from "pages/stations/components/stationMap/StationMap";

 
interface IContainerCharts {
	summary: { type: string; value: number; }[]
	summaryStats?: SummaryResponse;
	summaryForStation?: any;
	SummaryForAll?:any;
	summaryForStationV2?:any;
	expanded?:boolean;
	locationId?: string;
	shouldRefresh?: boolean;
	activeStats?: string[];
	inactiveStats?: string[];
	setActiveStats?: React.Dispatch<React.SetStateAction<string[]|undefined>>;
	setInactiveStats?: React.Dispatch<React.SetStateAction<string[]|undefined>>;
	setExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
}

const ContainerCharts: React.FC<IContainerCharts> = ({ summary, summaryStats,summaryForStation,summaryForStationV2,SummaryForAll,locationId, shouldRefresh, expanded, setExpanded, activeStats, setActiveStats, inactiveStats, setInactiveStats}) => {
	
	const { width } = useWindowDimensions();
	const dispatch = useDispatch();
	const [saveStats, { isSuccess }] = useSaveStatsMutation();
	const { isLoggedIn } = useSelector(
		(state: rootReducerType) => state.authenticationReducer
	);

	const { stations } = useSelector(
		(state: rootReducerType) => state.stationsReducer
	);

	const { stationId } = useSelector(
		(state: rootReducerType) => state.stationIdReducer
	);

	const params = {
		userName: emailToUsername(decodeJWT(isLoggedIn).email),
		activeStats: activeStats,
		inactiveStats: inactiveStats
	};

	const [makers, setMakers] = useState<any[]>([])

	const mapMakers = useGetStationQuery(stations).data

	useEffect(() => {
		dispatch(
			dashboardApi.endpoints.getStation.initiate(
				{userName: emailToUsername(decodeJWT(isLoggedIn).email)},
				{ subscribe: false, forceRefetch: true }
			)
		);
	}, [])

	useEffect(() => {
		if(mapMakers) {
			let makersArr:any[] = []
			let makersKeys = Object.keys(mapMakers)
			let makersLocations:any[] = []

			makersArr = makersKeys.map((it, idx) => {
				let arr = mapMakers[it].geolocation.split(", ")
				arr = arr.map(el => {
					return parseFloat(el) 
				})
				makersLocations.push(arr)
				return {
					id: it,
					connectors: mapMakers[it].connectorsNum,
					latitude: arr[0],
					longitude: arr[1],
					color: "#ff1100",
					locStr: mapMakers[it].locationStr
				}
			})
			setMakers(makersArr) 
			dispatch({type: "SET_MAP_DATA", payload: {stations: makersArr}})
		}
	}, [mapMakers])

	useEffect(() => {
	if(isSuccess)
		Notification({ type: "success", message: i18n.t("dashboard.toastTitle"), description: i18n.t("dashboard.toastCustomisationSave")});
	},[isSuccess]);

	const removeStat = (index:number) => {
		if(setActiveStats && setInactiveStats && activeStats && inactiveStats) {
			setActiveStats(activeStats.filter((_,i) => i !=index));
			setInactiveStats([...inactiveStats,activeStats[index]]);
		}
	};

	const addStat = (index:number) => {
		if(inactiveStats && setInactiveStats)
			setInactiveStats(inactiveStats.filter((_,i) => i !=index));
		if(activeStats && inactiveStats && setActiveStats)
			setActiveStats([...activeStats,inactiveStats[index]]);
	};

	const desktopCards = (summaryStats) => (<>
		{
			expanded && activeStats && setActiveStats? activeStats.map((stat,index)=> {
				return (
					<div key={uniqueId()} className="summary-card-container">
						<div className="action-image" onClick={()=> removeStat(index)}>
							<MinusButton fill="white"/>
						</div>					
						<InfoCard
							description={stat}
							simpleCard={true}
						/>
					</div>
				);}) :
				summaryStats ? Object.entries(summaryStats).map(([key, value]) => {
					if (key !== undefined && key !== null && value !== undefined && value !== null)
						return <InfoCard
						title={key}
						description={value as string}
						key={key}
					/>
					else return null;
				})
					: null}
	</>
	);

	const mobileCards = (summaryStats) => (
		<>	
			{expanded && activeStats && setActiveStats ? 
				<>
					<Button size="small" onClick={ () => {
						saveStats(params);
						dispatch(
							dashboardApi.endpoints.getSummaryStats.initiate({
								userName: params.userName,
						},
						{ subscribe: false, forceRefetch: true }));
						if(setExpanded) setExpanded(!expanded);
				}}> {i18n.t("dashboard.save")}</Button>

					<div className="customise-stats-section">
						<div className="customise-active-stats-section">
							<h3>{i18n.t("dashboard.activeStats")}</h3>
							{ activeStats.map((stat,index)=> {
								return (
									<div key={uniqueId()} className="summary-card-container" style={{
										height: "12vh",gap:"2vh",width:"100%"}}>
										<div className="action-image" onClick={()=> removeStat(index)}>
											<MinusButton fill="white"/>
										</div>					
										<InfoCard
											description={stat}
											simpleCard={true}
										/>
									</div>
								);})}
						</div>
						<div className="customise-inactive-stats-section">
							<h3>{i18n.t("dashboard.inactiveStats")}</h3>
							{ inactiveStats && inactiveStats.map((stat,index)=> {
								return (
									<div key={uniqueId()} className="summary-card-container" style={{
										height: "12vh",width:"100%"}}>
										<div className="action-image" onClick={()=> addStat(index)}>
											<MinusButton fill="white"/>
										</div>					
										<InfoCard
											description={stat}
											simpleCard={true}
										/>
									</div>
								);})}
						</div>	
					</div>
				</>:
				summaryStats ? Object.entries(summaryStats).map(([key, value]) => {
					if (key !== undefined && key !== null && value !== undefined && value !== null)
						return (					
							<InfoCard
								title={key}
								description={value as string}
								key={key}
							/>
						);
					else return null;
				})
					: null}
		</>);

	const data = {}

	return (<section className="main-container">
		<section className="section-cards">
			{width > 720
				? (!stationId ? desktopCards(summaryStats) : desktopCards(summaryForStation))
				: ((!stationId ? mobileCards(summaryStats) : mobileCards(summaryForStation))) 
				}
		</section>
		{/* <section style={{'width': '100%'}}>
			<Information summaryStats={summaryStats} summaryForStation={summaryForStation}/>
		</section> */}
		<section className="section-graphs">
			<Connectors connectorsData={summary} SummaryForAll={SummaryForAll} summaryForStationV2={summaryForStationV2} title={i18n.t("dashboard.ConnectorsTitle")} />
			<Details width={width} locationId={locationId} shouldRefresh={shouldRefresh}/>
		</section>
		<section className="board-map">
		{/* <div style={{'background': 'red', width: '100%', height: '500px'}}></div> */}
			<StationMap data={makers} stationData={mapMakers} />.
			{/* <Map markers={makers}/> */}
		</section>
		{/* <section className="section-graphs">
				<div style={{'background': 'red', width: '100%', height: '500px'}}></div>
		</section> */}
		
	</section>);
};

export default ContainerCharts;